import React, { Component } from 'react';
import Wrp from '../../hoc/Wrp/Wrp';
import { 
	TextField,
	EmailField,
	NumberField,
	/*Lookup,
	MultiLookup,*/
	DatePick,
	DateTimePick,
	CheckBox,
	// Decimal,
	Percentage,
	PickList,
	MultiSelect,
	SelectField,
	NumericWithDotField,
	PhoneField
} from './Fields';
import { withRouter } from 'react-router';
import LookupField from '../LookupField';

class Inputs extends Component {
    render() {
		console.log(this.props.fieldtype + 'fieldType')
		// console.log("value---------->",this.props.value);
		let dispFormCont = null;
		//let formDataType = JSON.parse(this.props.fieldtype);
		//console.log(this.props.fieldtype + 'this.props.fieldtype');
		switch(this.props.fieldtype) {
			case 'TextInput' :
				dispFormCont = <TextField attr1={this.props.attr1}  attr4={this.props.attr4} fieldtype={this.props.fieldtype} filterObject={this.props.filterObject} value={this.props.value} filterOnChange={this.props.filterOnChange}  attr6={this.props.attr6} attr6={this.props.attr6} classname={this.props.classname}/>;
				break;
			case 'Email' :
				dispFormCont = <EmailField attr1={this.props.attr1}  attr4={this.props.attr4} fieldtype={this.props.fieldtype} filterObject={this.props.filterObject}  value={this.props.value} filterOnChange={this.props.filterOnChange} attr6={this.props.attr6} classname={this.props.classname} />;
				break;
			/*case 'Number' :
				dispFormCont = <NumberField attr1={this.props.attr1}  attr4={this.props.attr4} fieldtype={this.props.fieldtype} filterObject={this.props.filterObject}  value={this.props.value} filterOnChange={this.props.filterOnChange} attr6={this.props.attr6} classname={this.props.classname} />;
				break;*/
			case 'Phone' :
				dispFormCont = <PhoneField attr1={this.props.attr1}  attr4={this.props.attr4} fieldtype={this.props.fieldtype} filterObject={this.props.filterObject} value={this.props.value} filterOnChange={this.props.filterOnChange} attr6={this.props.attr6} classname={this.props.classname} />;
				break;
			case 'Date' :
				dispFormCont = <DatePick  attr1={this.props.attr1}  attr4={this.props.attr4} fieldtype={this.props.fieldtype} filterObject={this.props.filterObject} value={this.props.value} filterOnChange={this.props.filterOnChange} attr5={this.props.attr5} attr6={this.props.attr6} classname={this.props.classname}/>;
				break;
			case 'DateTime' :
				dispFormCont = <DateTimePick attr1={this.props.attr1}  attr4={this.props.attr4} fieldtype={this.props.fieldtype} filterObject={this.props.filterObject} value={this.props.value} filterOnChange={this.props.filterOnChange} attr5={this.props.attr5} attr6={this.props.attr6} classname={this.props.classname}/>;
				break;
			case 'Time' :
				dispFormCont = <DateTimePick attr1={this.props.attr1}  attr4={this.props.attr4} fieldtype={this.props.fieldtype} filterObject={this.props.filterObject} value={this.props.value} filterOnChange={this.props.filterOnChange} attr6={this.props.attr6} classname={this.props.classname}/>;
				break;
			case 'Reminder' :
				dispFormCont = <DateTimePick attr1={this.props.attr1}  attr4={this.props.attr4} fieldtype={this.props.fieldtype} filterObject={this.props.filterObject} value={this.props.value} filterOnChange={this.props.filterOnChange} attr5={this.props.attr5} attr6={this.props.attr6} classname={this.props.classname}/>;
				break;				
			case 'CheckBoxes' :
				dispFormCont = <CheckBox handleChangeMultiple={this.props.handleChangeMultiple} handleChange={this.props.handleChange} options={this.props.options} attr1={this.props.attr1}  attr4={this.props.attr4} fieldtype={this.props.fieldtype} filterObject={this.props.filterObject} value={this.props.value} filterOnChange={this.props.filterOnChange} attr6={this.props.attr6} classname={this.props.classname} />;
				break;
			// case 'Decimal' :
			// 	dispFormCont = <Decimal fieldMappingData={this.props.fieldMappingData} fieldDetails={this.props.formData} changed={this.props.changed}/>;
			// 	break;
			case 'Percentage' :
				dispFormCont = <Percentage  attr1={this.props.attr1} attr5={this.props.attr5}  attr4={this.props.attr4} fieldtype={this.props.fieldtype} filterObject={this.props.filterObject} value={this.props.value} filterOnChange={this.props.filterOnChange} attr6={this.props.attr6} classname={this.props.classname}/>;	
				break;					
			/*case 'PickList' :
				dispFormCont = <PickList handleChangeMultiple={this.props.handleChangeMultiple} handleChange={this.props.handleChange} options={this.props.options} attr1={this.props.attr1}  attr4={this.props.attr4} fieldtype={this.props.fieldtype} filterObject={this.props.filterObject} value={this.props.value} filterOnChange={this.props.filterOnChange} />;
				break;*/
			case 'PickList' :
				dispFormCont = <MultiSelect handleChangeMultiple={this.props.handleChangeMultiple} handleChange={this.props.handleChange} options={this.props.options} attr1={this.props.attr1}  attr4={this.props.attr4} fieldtype={this.props.fieldtype} filterObject={this.props.filterObject} value={this.props.value} filterOnChange={this.props.filterOnChange} attr6={this.props.attr6} classname={this.props.classname}/>;
				break;
			case 'Currency' :
				dispFormCont = <NumericWithDotField attr1={this.props.attr1} attr5={this.props.attr5}  attr4={this.props.attr4} fieldtype={this.props.fieldtype} filterObject={this.props.filterObject} value={this.props.value} filterOnChange={this.props.filterOnChange} attr6={this.props.attr6} classname={this.props.classname}/>;	
				break;				
			case 'MultiSelect' :
				dispFormCont = <MultiSelect handleChangeMultiple={this.props.handleChangeMultiple} handleChange={this.props.handleChange} options={this.props.options} attr1={this.props.attr1}  attr4={this.props.attr4} fieldtype={this.props.fieldtype} filterObject={this.props.filterObject} value={this.props.value} filterOnChange={this.props.filterOnChange} attr6={this.props.attr6} classname={this.props.classname}/>;
				break;	
			case 'Lookup' :
				dispFormCont = <LookupField
								values={this.props.values}
								lookupWindowName={this.props.lookupWindowName}
								lookupWindowNameId={this.props.lookupWindowNameId}
								handleInputChange={e=>this.props.handleInputChange(e,this.props.attr1)}
								handleDelete={e=>this.props.handleDelete(e,this.props.attr1)}
								isNotes={this.props.isNotes}
								/>
				break;
			case 'MultiLookup' :
				dispFormCont = <LookupField
								values={this.props.values}
								lookupWindowName={this.props.lookupWindowName}
								lookupWindowNameId={this.props.lookupWindowNameId}
								handleInputChange={e=>this.props.handleInputChange(e,this.props.attr1)}
								handleDelete={e=>this.props.handleDelete(e,this.props.attr1)}
								isNotes={this.props.isNotes}
								/>
				break;
			case 'Email' :
				dispFormCont = <LookupField
								values={this.props.values}
								lookupWindowName={this.props.lookupWindowName}
								lookupWindowNameId={this.props.lookupWindowNameId}
								handleInputChange={e=>this.props.handleInputChange(e,this.props.attr1)}
								handleDelete={e=>this.props.handleDelete(e,this.props.attr1)}
								isNotes={this.props.isNotes}
								/>
				break;
			case 'User' :
				dispFormCont = <LookupField
								values={this.props.values}
								lookupWindowName={this.props.lookupWindowName}
								lookupWindowNameId={this.props.lookupWindowNameId}
								handleInputChange={e=>this.props.handleInputChange(e,this.props.attr1)}
								handleDelete={e=>this.props.handleDelete(e,this.props.attr1)}
								isNotes={this.props.isNotes}
								/>
				break;								
			default :
				dispFormCont = <TextField attr1={this.props.attr1} attr5={this.props.attr5}  attr4={this.props.attr4} fieldtype={this.props.fieldtype} filterObject={this.props.filterObject} value={this.props.value} filterOnChange={this.props.filterOnChange} attr6={this.props.attr6} classname={this.props.classname}/>;	
		}
		return (
			<Wrp>
				{/* {this.props.formFields} */}
				{/*this.state.displayFormCont*/}
				{dispFormCont}
			</Wrp>
		);
	}
}



export default Inputs;